import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
}
export function CTAButton({
  children,
  href = '#pricing',
  className = ''
}: CTAButtonProps) {
  const isAnchor = href.startsWith('#');
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isAnchor) {
      e.preventDefault();
      const el = document.getElementById(href.substring(1));
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  const classes = `
    block w-full text-center cursor-pointer
    px-4 py-4
    font-body font-bold text-lg uppercase tracking-wide
    bg-gold text-white
    border-b-4 border-[#A68A4A]
    ${className}
  `;
  return <a href={href} onClick={handleClick} target={isAnchor ? undefined : '_blank'} rel={isAnchor ? undefined : 'noopener noreferrer'} className={classes} data-id="element-36">
      {children}
    </a>;
}